import { fetchApi } from '@/config/axiosSetting';

import {
  BodySingleSubstitutionPartsListParams,
  BodySingleSubstitutionPartsListResponse,
} from '@/modules/adjusterReportModules/Insurer-information/queries/getBodySingleSubstitutionPartsList/getBodySingleSubstitutionPartsListQuery.type';

export const getBodySingleSubstitutionPartsListQueryFunction = (
  params: BodySingleSubstitutionPartsListParams,
): Promise<BodySingleSubstitutionPartsListResponse> =>
  fetchApi.get(`body/reports/${params.id}/adjusting/substitution_parts/`, {
    params,
  });
